import React from 'react';

const SimulatorValidation = () => {
    return <div>SimulatorValidation</div>;
};

export default SimulatorValidation;
